// This import loads the firebase namespace along with all its type information.
import Flag from './flag-model'

export async function load_flags(): Promise<Flag[]> {
  throw 'Not implemented'
}

export async function delete_flag(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_flag(): Promise<Flag> {
  throw 'Not implemented'
}
